import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getPromotions = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(
    `v1/promotion?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const getPromotion = async (id: string) => {
  return await customFetch(`v1/promotion/${id}`, {
    method: "GET",
  });
};
export const createPromotion = async (data: any) => {
  return await customFetch("v1/promotion", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updatePromotion = async (id: string, data: any) => {
  return await customFetch(`v1/promotion/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deletePromotion = async (id: string) => {
  return await customFetch(`v1/promotion/${id}`, {
    method: "DELETE",
  });
};



export const addPromotionRule = async (id: string, data: any) => {
  return await customFetch(`v1/promotion/${id}/rule`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deletePromotionRule = async (id: string, ruleId: string) => {
  return await customFetch(`v1/promotion/${id}/rule/${ruleId}`, {
    method: "DELETE",
  });
};

export const addPromotionAction = async (id: string, data: any) => {
  return await customFetch(`v1/promotion/${id}/action`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deletePromotionAction = async (id: string, actionId: string) => {
  return await customFetch(`v1/promotion/${id}/action/${actionId}`, {
    method: "DELETE",
  });
};
